export default __webpack_public_path__ + "static/cmatic-logo-white-b1b49e4c67f64c18b64f7bbfcdd604f0.svg";